module.exports = __webpack_public_path__ + "img/LUB00197.53dead3d.svg";